import { createContext } from 'react';

import { SearchByMlsNumberState } from './searchByMlsNumber.reducer';

export const searchByMlsNumberState: SearchByMlsNumberState = {};

const initialValue: {
  state: SearchByMlsNumberState;
  onSubmit: (queryKey: string, value: string) => void;
} = {
  state: searchByMlsNumberState,
  onSubmit: () => {
    return;
  },
};

export const SearchByMlsNumberContext = createContext(initialValue);
